import { NEW_DASHBOARD_ELIGIBLE_TESTERS } from '../constants';

export const getUserEligibleNewMetrics = (email) => {
  return NEW_DASHBOARD_ELIGIBLE_TESTERS.includes(email);
};
